export default __webpack_public_path__ + "static/media/setup-intro-image.397971ae.jpg";